export default {
  title: 'Kup e-karty podarunkowe',
  subtitle:
    'Podaruj kartę podarunkową od {{companyName}}. Idealna na urodziny, podziękowanie lub bez okazji – do wykorzystania na jedzenie i napoje.',
  header: {
    title: 'Karta podarunkowa',
    subtitle: 'Podaruj radość',
  },
  buttons: {
    buy_now: 'Kup teraz',
  },
};
